<div class="loader">
    <span></span>
</div>
